import BottomNav from './BottomNav';
import NudgeBanner from './NudgeBanner';
import './AppShell.css';

export default function AppShell({ children }) {
  return (
    <div className="app-shell">
      <main className="app-content">
        <NudgeBanner />
        {children}
      </main>
      <BottomNav />
    </div>
  );
}
